import React, { useEffect } from 'react';

import { Dropdown } from '../../../../common/Dropdown';
import { Spinner } from '../../../../components/Spinner';
import { useTeam } from '../../contexts/TeamContext';
import { Sprint } from '../../types';

export function SprintsDropdown({
  className,
  selectedSprint,
  setSelectedSprint,
  sprints,
  setSelectedDate,
  isLoading,
}: {
  className?: string;
  selectedSprint: Sprint | null;
  setSelectedSprint: (sprint: Sprint | null) => void;
  sprints: Sprint[] | undefined;
  setSelectedDate: (date: Date) => void;
  isLoading: boolean;
}): JSX.Element {
  const { team } = useTeam();
  useEffect(() => {
    // Reset selected sprint when team changes
    if (team) {
      setSelectedSprint(null);
    }
  }, [team, setSelectedSprint]);

  useEffect(() => {
    if (sprints && !selectedSprint) {
      const activeSprint = sprints.find((sprint) => sprint.status === 'active');
      if (activeSprint) {
        setSelectedSprint(activeSprint);
      } else if (sprints.length > 0) {
        setSelectedSprint(sprints[0]);
      }
    }
  }, [sprints, selectedSprint, setSelectedSprint]);

  if (isLoading) {
    return <Spinner />;
  }

  const options =
    sprints?.map((sprint) => ({
      id: sprint.id,
      value: sprint.id,
      label: sprint.name,
    })) || [];

  const value = selectedSprint
    ? {
        id: selectedSprint.id,
        value: selectedSprint.id,
        label: selectedSprint.name,
      }
    : null;

  return (
    <Dropdown
      name="sprintId"
      label="Select Sprint"
      className={className}
      options={options}
      value={value}
      onChange={(option) => {
        const sprint = sprints?.find((s) => s.id === option?.value) ?? null;
        setSelectedSprint(sprint);
        setSelectedDate(new Date(sprint?.startDate || ''));
      }}
    />
  );
}
